class PredictiveSearch extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector('#predictive-search');

        if (!this.input || !this.predictiveSearchResults) return;

        this.input.addEventListener('input', this.debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));
    }

    onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
            this.close();
            return;
        }

        this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
        const searchForm = this.input.form;
        const searchAction = searchForm?.getAttribute('action') || '/search';
        const searchUrl = new URL(searchAction, window.location.origin);
        searchUrl.pathname = `${searchUrl.pathname.replace(/\/search\/?$/, '')}/search/suggest`;
        searchUrl.search = '';
        searchUrl.searchParams.set('q', searchTerm);
        searchUrl.searchParams.set('section_id', 'section-predictive-search');

        return fetch(searchUrl.toString())
            .then((response) => {
                if (!response.ok) {
                    var error = new Error(response.status);
                    this.close();
                    throw error;
                }

                return response.text();
            })
            .then((text) => {
                const resultsSection = new DOMParser()
                    .parseFromString(text, 'text/html')
                    .querySelector('#shopify-section-section-predictive-search');

                if (!resultsSection) {
                    throw new Error('Predictive search response is missing its results section');
                }

                const resultsMarkup = resultsSection.innerHTML;
                this.predictiveSearchResults.innerHTML = resultsMarkup;
                this.open();
            })
            .catch((error) => {
                this.close();
                throw error;
            });
    }

    open() {
        this.predictiveSearchResults.style.display = 'block';
    }

    close() {
        this.predictiveSearchResults.style.display = 'none';
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }
}

if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch);
}
